import React from 'react';
import * as S from './style';
import { awardImages } from '../../../../../landing-pages/js/screens/success-stories/data';
import Image from '../../../components/loggedout/common/Image';

const Awards = () => {
  return (
    <S.ImageWrapper>
      {awardImages &&
        awardImages.map((item, idx) => {
          return <Image key={idx} src={item} />;
        })}
    </S.ImageWrapper>
  );
};

export default Awards;
